import { ChatMessage } from "@/core/models/chat.model";
import AssistantMessageContent from "./AssistantMessageContent";

interface Props {
  message: ChatMessage;
}

function renderUserContent(content: string) {
  if (!content) return null;
  return content.split("\n").map((line, i) => (
    <p key={i} className="mb-1 last:mb-0 whitespace-pre-wrap break-words">
      {line}
    </p>
  ));
}

export default function MessageBubble({ message }: Props) {
  if (message.role === "tool") return null;

  const isUser = message.role === "user";

  if (isUser) {
    return (
      <div className="flex justify-end">
        <div className="max-w-[85%] md:max-w-[75%]">
          <p className="text-xs text-slate-400 mb-1.5 text-right">Bạn</p>
          <div className="bg-slate-900 text-white rounded-lg rounded-tr-sm px-4 py-3 text-base leading-relaxed">
            {renderUserContent(message.content)}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-col">
      <div className="flex items-center gap-2 mb-2">
        <span
          className="w-1.5 h-1.5 rounded-full"
          style={{ background: "var(--primary-color)" }}
        />
        <p className="text-xs font-medium text-slate-500">Trợ lý DVN</p>
      </div>

      <div className="text-base leading-relaxed text-slate-800">
        {message.content ? (
          <AssistantMessageContent content={message.content} />
        ) : message.isStreaming ? (
          <span className="inline-flex items-center gap-1.5 text-slate-400">
            <span className="w-1.5 h-1.5 bg-slate-400 rounded-full animate-pulse" />
            <span className="text-sm">Đang soạn</span>
          </span>
        ) : (
          <span className="text-sm text-slate-400 italic">(trống)</span>
        )}
      </div>
    </div>
  );
}
